module.exports = __webpack_public_path__ + "static/media/sid1.ee94df94.jpeg";